module.exports = __webpack_public_path__ + "img/logo.b34e79a7.svg";